import script from "./DashboardHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardHeader.vue?vue&type=style&index=0&id=accf93b0&lang=scss&scoped=true"
import "./DashboardHeader.vue?vue&type=style&index=1&id=accf93b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-accf93b0"]])

export default __exports__